import Modal from "react-modal";
import { Button } from "../..";
import { useSelector } from "react-redux";
import { appSelector } from "@podcasts/store/application";
import { ERROR_CODES } from "../../../constants/error";
import styles from "./EmailInUseModal.module.scss";
import { useEffect, useState } from "react";

interface EmailInUseModalProps {
  isOpen: boolean;
  onOk: () => void;
}

export function EmailInUseModal({ isOpen, onOk }: EmailInUseModalProps) {
  const { errorCode: registerErrorCode } = useSelector(appSelector) as any;
  const [calendlyUrl, setCalendlyUrl] = useState(
    "https://calendly.com/rachel-podcastfellowship/30min-1"
  );

  useEffect(() => {
    if (registerErrorCode === ERROR_CODES.EMAIL_EXISTS_WITH_OLDER) {
      setCalendlyUrl("https://calendly.com/rina-podcastfellowship/30min");
    } else {
      setCalendlyUrl("https://calendly.com/rachel-podcastfellowship/30min-1");
    }
  }, [registerErrorCode]);

  return (
    <Modal
      isOpen={isOpen}
      closeTimeoutMS={200}
      style={{
        overlay: {
          zIndex: 99,
        },
        content: {
          width: 600,
          height: 350,
          borderRadius: 20,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "auto",
          zIndex: 1,
        },
      }}
    >
      <div>
        <span className="icon-notice" />
      </div>
      {registerErrorCode === ERROR_CODES.EMAIL_EXISTS && (
        <div>
          It looks like you've applied before. If there's a reason why you are
          submitting another application, or if you are receiving this message
          in error, please reach out to{" "}
          <a href="mailto:leah@podcastfellowship.org">
            leah@podcastfellowship.org
          </a>
        </div>
      )}
      {registerErrorCode !== ERROR_CODES.EMAIL_EXISTS && (
        <div>
          It looks like you've applied before. If you still need to schedule an
          interview, you can do that here:
          <a href={calendlyUrl}>{calendlyUrl}</a> <br />
          If there's a reason why you are submitting another application, or if
          you are receiving this message in error, please reach out to{" "}
          <a href="mailto:leah@podcastfellowship.org">
            leah@podcastfellowship.org
          </a>
        </div>
      )}
      <div style={{ width: 256, marginTop: 28 }}>
        <Button name="Ok" onClick={onOk} />
      </div>
    </Modal>
  );
}

export default EmailInUseModal;
